<template>
  <b-form-group
    :label="label + (isEdit ?'' : ' *')"
    label-for="password-input"
    class="bold-label"
    :state="password.state"
    :invalid-feedback="password.invalidFeedback"
    :description="(isEdit ? this.$i18n.t('Password.text') : '' )">
    <div class="password-line">
      <b-input-group>
        <b-form-input
          id="password-input"
          v-model="password.value"
          :type="showPassword ?'text' : 'password'"
          :required="!isEdit"
          :state="password.state"
          :minLength="minLength"
          v-on:change="removeInvalidFeedback">
        </b-form-input>
        <b-input-group-append>
          <div class="eye-button form-control" @click="togglePassword" >
            <eye-icon v-if="!showPassword"></eye-icon>
            <eye-off-icon v-else></eye-off-icon>
          </div>
        </b-input-group-append>
      </b-input-group>
      <b-button v-if="showGenerate" class="ml-1" variant="light" @click="generatePassword">
        <refresh-icon></refresh-icon>
      </b-button>
    </div>
    <b-form-text>{{helpMessage}}</b-form-text>
  </b-form-group>
</template>

<script>
export default {
  name: 'PasswordCreationField',

  props: {
    minLength: {
      type: Number,
      default: 8
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    showGenerate: {
      type: Boolean,
      default: false
    },
    password: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: function () {
        return this.$t('Password')
      }
    },
    helpMessage: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      showPassword: false
    }
  },

  methods: {
    togglePassword () {
      this.showPassword = !this.showPassword
    },
    generatePassword () {
      var chars = '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      var passwordLength = 8
      var passwordG = ''
      for (var i = 0; i <= passwordLength; i++) {
        var randomNumber = Math.floor(Math.random() * chars.length)
        passwordG += chars.substring(randomNumber, randomNumber + 1)
      }
      this.password.value = passwordG
    },

    removeInvalidFeedback () {
      this.password.state = null
      this.password.invalidFeedback = null
    }
  }
}
</script>

<style scoped>

.password-line{
  display: flex;
  flex-direction: row;
}

#password-input {
  border-right: none;
}

.eye-button {
  border: 1px solid var(--main-border-color) !important;
  border-left: none;
  border-radius: 0 var(--small-border-radius) var(--small-border-radius) 0;
  padding-left: 1em;
  padding-right: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--main-color) !important;
  background-color: var(--background-grey) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/PasswordCreationField.vue